import React, { useState } from 'react';

import AppContext from './index';

// Alert types: error, warning, info, success
const AlertProvider = ({ children }) => {
  const [alertState, setAlertState] = useState({
    show: false,
    type: '',
    message: '',
    loader: false
  });
  const context = {
    alertState,
    setAlertState
  };
  return <AppContext.Provider value={context}>{children}</AppContext.Provider>;
};
export default AlertProvider;
